module.exports = __webpack_public_path__ + "img/user.ce8e8698.svg";